export default __webpack_public_path__ + "static/media/zayed-project-6.85c94269.jpg";